import React, { useState, useContext } from 'react'
import {
	Button,
	Card,
	CardBody,
	Col,
	Modal,
	Row
} from 'reactstrap'
import { SpinnerComponent } from 'react-element-spinner'

import { trigger } from '../../events/customEvents'
import AuctionTabsService from '../../services/AuctionTabsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'

/**
 * SellConfirmationModal - Confirmation dialog before selling at high bid.
 * BRD: "Sell – Unit will be sold at the current high bid. Pop up to confirm - if Yes:
 * Unit to go into sold status, Email notification sent to high bidder confirming the sale,
 * Dealer to be able to see as a purchase"
 */
const SellConfirmationModal = ({ isOpen = false, auction = null, onClose, onSuccess }) =>
{
	const [isModalBusy, setIsModalBusy] = useState(false)
	const sessionContext = useContext(SessionContext)

	const handleCancelModal = () =>
	{
		if (typeof onClose === 'function')
		{
			onClose()
		}
	}

	const handleConfirmSell = () =>
	{
		setIsModalBusy(true)
		const bidId = auction?.highBidAuctionTierMemberBidId || auction?.highBidId || auction?.auctionTierMemberBidId

		AuctionTabsService
			.sellAtHighBid(auction.auctionId, bidId, '', sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				const highBid = auction?.highBid || auction?.currentHighBid || 0
				trigger('raiseNotification', { 
					title: 'Sale Completed', 
					message: `Vehicle sold for $${highBid.toLocaleString()}. Confirmation email sent to buyer.`, 
					type: 'success', 
					duration: 5 
				})
				if (typeof onSuccess === 'function')
				{
					onSuccess()
				}
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}

	// Get VIN for display (BRD mockup format)
	const vin = auction?.vin || auction?.vehicleVin || ''

	return (
		<Modal
			className="modal-dialog-centered"
			size="md"
			isOpen={isOpen}
		>
			<SpinnerComponent
				loading={isModalBusy}
				position="centered"
				message="Processing sale..."
			/>
			<Card className="mb-0">
				<CardBody>
					{/* BRD: Title shows VIN */}
					<div className="text-muted mb-3">
						<strong>VIN:{vin} has a bid on it</strong>
					</div>
					
					{/* BRD: Simple confirmation message */}
					<p className="mb-4">
						Please confirm you would like to sell at current high bid
					</p>

					<Row>
						<Col className="text-center">
							<Button
								color="primary"
								className="me-2"
								onClick={handleConfirmSell}
							>
								YES
							</Button>
							<Button
								color="secondary"
								onClick={handleCancelModal}
							>
								Cancel
							</Button>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Modal>
	)
}

export default SellConfirmationModal
